"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VapiConfigOutSerializer = void 0;
exports.VapiConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=vapiConfigOut.js.map